export default __webpack_public_path__ + "static/media/home-yoga-meditation-popular-classes-img03.41b0dbde.jpg";